import React from 'react';
const  ReactEventDispatcherContext = React.createContext()

export default ReactEventDispatcherContext